import {
  fetchDownloadsfail,
  fetchDownloadsrequest,
  fetchDownloadssuccess,

  fetchPRfail,
  fetchPRrequest,
  fetchPRsuccess
} from '../store/ActionReducers/pressReleaseDownloads.actionreducer';

import {Dispatch} from 'redux';
import { httpbase } from '../utils/axios.utils';
import { lang } from '../config/app.config';



export const fetchPR = (page:number = 1,branch:string|undefined=undefined)=>{
  return async (dispatch:Dispatch) =>{
    dispatch(fetchPRrequest());
    try{
      const response = await httpbase().get(`resources/press-release/?lang=${lang}&page=${page}${branch?'&branch='+branch:''}`);
      const pressReleases = response.data.data || undefined;
      const meta = response.data.meta || undefined;
      dispatch(fetchPRsuccess({pressReleases:pressReleases,meta:meta}));
    }catch(e:any){
      if(e && e.response && e.response.data){
        dispatch(fetchPRfail(e.response.data));
      }
      dispatch(fetchPRfail("Something went wrong!"));
    }
  }
}


export const fetchDownloads = (page:number = 1,branch:string|undefined=undefined)=>{
  return async (dispatch:Dispatch) =>{
    dispatch(fetchDownloadsrequest());
    try{
      const response = await httpbase().get(`resources/download/?lang=${lang}&page=${page}${branch?'&branch='+branch:''}`);
      const downloads = response.data.data || undefined;
      const meta = response.data.meta || undefined;
      dispatch(fetchDownloadssuccess({downloads:downloads,meta:meta}));
    }catch(e:any){
      if(e && e.response && e.response.data){
        dispatch(fetchDownloadsfail(e.response.data));
      }
      dispatch(fetchDownloadsfail("Something went wrong!"));
    }
  }
}